import { render, staticRenderFns } from "./outbound-record.vue?vue&type=template&id=3472bd11&scoped=true&"
import script from "./outbound-record.vue?vue&type=script&lang=js&"
export * from "./outbound-record.vue?vue&type=script&lang=js&"
import style0 from "./outbound-record.vue?vue&type=style&index=0&id=3472bd11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472bd11",
  null
  
)

export default component.exports